var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DDD9F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5841_68959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4971 23.248H44.4971",
    stroke: "#453597",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4971 29.498H44.4971",
    stroke: "#453597",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4971 40.75H19.4971V22C19.4971 21.0054 19.8922 20.0516 20.5954 19.3483C21.2987 18.6451 22.2525 18.25 23.2471 18.25H40.7471C41.7416 18.25 42.6955 18.6451 43.3987 19.3483C44.102 20.0516 44.4971 21.0054 44.4971 22V40.75Z",
    stroke: "#453597",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4971 40.748V44.498C44.4971 44.8296 44.3654 45.1475 44.131 45.3819C43.8965 45.6164 43.5786 45.748 43.2471 45.748H39.4971C39.1655 45.748 38.8476 45.6164 38.6132 45.3819C38.3788 45.1475 38.2471 44.8296 38.2471 44.498V40.748",
    stroke: "#453597",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7471 40.748V44.498C25.7471 44.8296 25.6154 45.1475 25.381 45.3819C25.1465 45.6164 24.8286 45.748 24.4971 45.748H20.7471C20.4155 45.748 20.0976 45.6164 19.8632 45.3819C19.6288 45.1475 19.4971 44.8296 19.4971 44.498V40.748",
    stroke: "#453597",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3691 37C27.4047 37 28.2441 36.1605 28.2441 35.125C28.2441 34.0895 27.4047 33.25 26.3691 33.25C25.3336 33.25 24.4941 34.0895 24.4941 35.125C24.4941 36.1605 25.3336 37 26.3691 37Z",
    fill: "#453597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6152 37C38.6508 37 39.4902 36.1605 39.4902 35.125C39.4902 34.0895 38.6508 33.25 37.6152 33.25C36.5797 33.25 35.7402 34.0895 35.7402 35.125C35.7402 36.1605 36.5797 37 37.6152 37Z",
    fill: "#453597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4941 24.5V28.25",
    stroke: "#453597",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4922 24.5V28.25",
    stroke: "#453597",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5841_68959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(11.9971 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.7a77889f4f4645c6aaec1f9b01609468.svg";
export { ForwardRef as ReactComponent };